import script from "./Certification.vue?vue&type=script&setup=true&lang=ts"
export * from "./Certification.vue?vue&type=script&setup=true&lang=ts"

import "./Certification.vue?vue&type=style&index=0&id=5f601f4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f601f4f"]])

export default __exports__